export default __webpack_public_path__ + "static/media/download_appstore.7fd3c197.svg";